import './index.scss';
import React from "react";
import CustomPopup from "./CustomPopup";
import ButtonComponent from "../Button/Button";

interface Props {
  display: boolean;
  onChangeDisplay: () => void;
  title: string;
  description: string;
  onConfirm: () => void;
}

const ConfirmationPopup: React.FunctionComponent<Props> = ({
  display,
  onChangeDisplay,
  title,
  description,
  onConfirm,
}: Props) => {
  const handleClose = () => {
    onChangeDisplay();
  };

  return (
    <CustomPopup isOpen={display} onClose={handleClose}>
      <div
        style={{
          maxHeight: "500px !important",
          margin: "0px !important",
          zIndex: "500 !important",
        }}
      >
        <div
          className="drawerErrorPopupHeader"
          style={{
            position: "sticky",
            top: 0,
            right: 0,
            left: 0,
            background: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
            zIndex: 1,
          }}
          onTouchMove={(e) => {
            if (display) {
              handleClose();
            }
          }}
        >
          <div
            style={{
              width: "5%",
              border: "2px solid var(--border-card)",
              borderRadius: "16px",
              marginBottom: "2rem",
            }}
          ></div>
        </div>
        <div
          style={{
            maxHeight: "450px",
            overflowY: "auto",
            paddingTop: "10px",
            paddingLeft: "50px",
            paddingRight: "50px",
            paddingBottom: "10px",
            marginTop: "0px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingBottom: "2rem",
            }}
          >
            <div
              className="errorPopupTitle"
              style={{
                fontSize: "16px !important",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
              {title}
            </div>
            <div
              style={{
                fontSize: "14px !important",
                textAlign: "center",
                marginBottom: "2rem",
                paddingLeft: "2rem",
                paddingRight: "2rem",
              }}
            >
              {description}
            </div>
            <div className="confirmationButtonWrapper">
              <ButtonComponent
                disabled={false}
                id={"close_button"}
                variant="outlined"
                key={"cancelPopupButton"}
                style={"btnTutup"}
                onClick={onChangeDisplay}
                label="Batal"
              />
              <ButtonComponent
                disabled={false}
                id={"submit_button"}
                variant="contained"
                key={"outPopupButton"}
                style={"btnTutup"}
                onClick={onConfirm}
                label="Keluar"
              />
            </div>
          </div>
        </div>
      </div>
    </CustomPopup>
  );
};

export default ConfirmationPopup;
